(ns dashboard.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::maybe-string (s/nilable string?))
(s/def ::city ::maybe-string)
(s/def ::country ::maybe-string)
(s/def ::number ::maybe-string)
(s/def ::postal ::maybe-string)
(s/def ::prefix ::maybe-string)
(s/def ::state ::maybe-string)
(s/def ::street ::maybe-string)
(s/def ::street-type ::maybe-string)

(s/def ::address (s/keys :opt-un [::city
                                  ::country
                                  ::number
                                  ::postal
                                  ::prefix
                                  ::state
                                  ::street
                                  ::street-type]))
(s/def ::email ::maybe-string)
(s/def ::name string?)
(s/def ::phone ::maybe-string)
(s/def ::advisor (s/nilable (s/keys :req-un [::name]
                                    :opt-un [::address
                                             ::email
                                             ::phone])))

(s/def ::net-worth number?)
(s/def ::assets (s/and number? #(>= % 0)))
(s/def ::liabilities (s/and number? #(>= 0 %)))

(s/def ::totals (s/keys :req-un [::net-worth
                                 ::assets
                                 ::liabilities]))

(s/def ::net number?)
(s/def ::internal-net number?)
(s/def ::external-net number?)

(s/def ::accounts-net (s/keys :req-un [::net
                                       ::internal-net
                                       ::external-net]))

(s/def ::due-date (s/nilable string?))
(s/def ::status #{"COMPLETE"
                  "IN_PROCESS"
                  "NOT_STARTED"})
(s/def ::subject (s/nilable string?))
(s/def ::todo (s/keys :req-un [::due-date
                               ::status
                               ::subject]))

(s/def ::todo-list (s/nilable (s/coll-of ::todo)))

(s/def ::context #{:dashboarding
                   :editing-priorities})

(s/def ::dashboard (s/keys :req-un [::context]
                           :opt-un [::advisor
                                    ::accounts-net
                                    ::todo-list
                                    ::totals]))
